import { Injectable } from '@angular/core';

const STORAGE_KEY = 'jf-reporting-token';

@Injectable({ providedIn: 'root' })
export class AuthTokenService {
    public get token(): string | null {
        return sessionStorage.getItem(STORAGE_KEY);
    }

    // Must run before Angular bootstrap so the first HTTP/DevExpress request
    // carries the token; capture and strip ?token= before the URL can be logged.
    public static captureFromUrl(): string | null {
        const url = new URL(window.location.href);
        const token = url.searchParams.get('token');
        if (token) {
            sessionStorage.setItem(STORAGE_KEY, token);
            url.searchParams.delete('token');
            window.history.replaceState({}, document.title, url.toString());
        }
        return sessionStorage.getItem(STORAGE_KEY);
    }

    public withToken(url: string): string {
        const token = this.token;
        const theme = sessionStorage.getItem('jf-theme');
        if (!token && !theme) return url;
        const u = new URL(url, window.location.origin);
        if (token) u.searchParams.set('token', token);
        if (theme) u.searchParams.set('theme', theme);
        return u.toString();
    }
}
